module.exports = {"title":"Artists","showMore":"Show more","showLess":"Show less","close":"Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Stream/StreamArtistsModal/locales/fr.json
// module id = 1810
// module chunks = 0